import React from 'react';
import { connect } from 'react-redux';
import {
  deleteImageSamples, deleteWritingSamples, fetchImageSamples, fetchWritingSamples,
  fetchSampleGroups
} from 'registration/creative/ducks';
import WorkSamples from 'registration/creative/components/work_samples';

const mapStateToProps = ({ creativeRegistration: { workSamples, workSamplesMeta, sampleGroups } }) => {
  return {
    groups: sampleGroups,
    samples: workSamples,
    samplesMeta: workSamplesMeta
  };
}

export default connect(mapStateToProps, {
  fetchImageSamples,
  fetchWritingSamples,
  deleteImageSamples,
  deleteWritingSamples,
  fetchSampleGroups,
})(WorkSamples);



// WEBPACK FOOTER //
// ./registration/creative/containers/work_samples.jsx